import { FormResource } from "../locales";

export const form: FormResource = {
    rangeOverflow: "Värdet får inte vara högre än {{max}}.",
    rangeUnderflow: "Värdet får inte vara lägre än {{min}}.",
    required: "Fältet krävs.",
    invalidEmail: "Ogiltig e-postadress",
};
